<!-- eslint-disable vue/no-mutating-props -->
<template>
  <Card :class="['p-mr-2 p-mb-2 editable-alarm-card', isSelected ? 'card-selected' : '']">
    <template #header>
      <div style="padding: 0 8px 0 8px;">
        <InputText
            v-model="button['custom-name']"
            :placeholder="_t('label_Alarm_name')"
            class="p-mb-2 p-mt-2"
            style="width:100%; height: 40px;"
            type="text"
        />
      </div>
    </template>
    <template #content>
      <div style="width: 100%; display: flex; justify-content: center; align-items: center; margin-bottom: 6px; gap: 6px;">
        <div class="app-alarm-check">
          <input id="isAppAlarm" v-model="button.appAlarm" type="checkbox">
          <label for="isAppAlarm">App</label>
        </div>
        <i
            :class="`icon_big ${(button.icon && button.icon.name) || 'mdi mdi-alert-outline'}`"
            :style="`color: ${button.textColor || '#ffffff'}; background: ${button.bgColor || 'gray'}; cursor: pointer;`"
            @click="$emit('icon-click')"
        />
        <block-size-change
            :active-size="activeSize"
            @on-change="$emit('size-change', $event)"
            @on-open-dialog="$emit('color-click')"
        />
      </div>
      <Dropdown
          v-model="button.alarmid"
          dataKey="id"
          :options="alarmOptions"
          :placeholder="_t('menu.alarm_points')"
          class="p-mb-2"
          appendTo="body"
          resetFilterOnClear
          resetFilterOnHide
          optionLabel="name"
          optionValue="alarmPointId"
          style="width: 100%;"
          @change="$emit('alarm-select', button)"
      >
        <template #header>
          <InputText
              :modelValue="alarmSearch"
              :placeholder="_t('label_search_by_alarm_id_or_name')"
              @input="$emit('update:alarmSearch', $event.target.value)"
              style="width: calc(100% - 1rem); padding: 0.5rem; margin: 0.5rem;"
          />
        </template>
        <template #option="slotProps">
          <div class="p-dropdown-option">
            {{ slotProps.option.alarmPointId }} | {{ slotProps.option.name }}
          </div>
        </template>
      </Dropdown>
      <div class="p-d-flex p-jc-between p-ai-center p-mt-1" style="gap: 8px;">
        <div class="p-d-flex p-pb-2" style="gap: 4px; flex-wrap: nowrap; font-size: 0.8rem;">
          <Button
              v-tooltip.bottom="'Delete alarm button'"
              class="p-button-outlined p-button-danger p-flex-shrink-0"
              icon="pi pi-times"
              style="font-size: 0.6rem;"
              @click="$emit('delete')"
          />
          <Button class="p-button-outlined p-button-secondary p-button-sm" @click="$emit('cancel')">
            {{ _t('Cancel') }}
          </Button>
          <Button class="p-button-outlined p-button-help p-button-sm" :disabled="!button.alarmid" @click="$emit('view')">
            {{ _t('label_view') }}
          </Button>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import BlockSizeChange from '../../../components/BlockSizeChange'

export default {
  name: 'AlarmButtonEditCard',
  components: { BlockSizeChange },
  props: {
    button: { type: Object, required: true },
    isSelected: { type: Boolean, default: false },
    alarmOptions: { type: Array, default: () => [] },
    alarmSearch: { type: String, default: '' },
    activeSize: { type: String, default: 'medium' },
  },
  emits: ['icon-click', 'color-click', 'size-change', 'delete', 'cancel', 'view', 'alarm-select', 'update:alarmSearch'],
}
</script>
